import { render } from "./ToranomakiComponent.vue?vue&type=template&id=317c4845&scoped=true&ts=true"
import script from "./ToranomakiComponent.vue?vue&type=script&lang=ts"
export * from "./ToranomakiComponent.vue?vue&type=script&lang=ts"

import "./ToranomakiComponent.vue?vue&type=style&index=0&id=317c4845&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-317c4845"]])

export default __exports__